/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonGroup, ButtonVariant, Drawer, Icon, Intent, Overlay2, Position } from "@blueprintjs/core"
import { useEffect, useMemo, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { Hint } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { ICurrentEditType, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { getFullSingleContentSchema, schema } from "src/modules/pe-landing-module/data/schema"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import FieldChanger from "../FieldChanger"
import CanvasEditCanvas from "./CanvasEditCanvas"
import { isShowByGrands } from "src/modules/pe-landing-module/widgets/composite/LandingCompositeDefault"

/* Protopia Ecosystem component */
export interface ICanvasEditFormProps {
    sectionId: ID
    value: any
    onChange: ( val: any, field: string ) => void
    onUpdate: () => void
    onClose: () => void
}
const CanvasEditForm = ({ onClose, ...props }: ICanvasEditFormProps): JSX.Element => {
    const currentLanding                    = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const curEditModal: ICurrentEditType    = useLandingStore( (state: ILandingStore) => state.curEditModal ) 
    const [ isDifferent, setIsDifferent]    = useState<boolean>( false )    
    const [value, setValue]                 = useState<any>( props.value )

    useEffect(() => {
        setValue( props.value )
    }, [ props.value ]) 

    useEffect(() => {
        const hiddenElements = [ ".landing-tools-panel", ".pe-panel-layout-container", ".landing-top-panel", ".landing-hover-form" ]
        hiddenElements.forEach( el => {
            const element = document.querySelector( el )
            element?.classList.add( "d-none" )
        })
        document.querySelector(".landing-background")?.classList.add( "w-100" )
        document.querySelector(`.landing-canvas-${curEditModal.id}`)?.classList.add( "unvisibled" )
        return () => {
            hiddenElements.forEach( el => {
                const element = document.querySelector(el)
                element?.classList.remove("d-none")
            })
            document.querySelector(".landing-background")?.classList.remove( "w-100" )
            document.querySelector(`.landing-canvas-${curEditModal.id}`)?.classList.remove( "unvisibled" )
        }
    }, [])

    const onChange = ( val: any, field: string ) => {
        setValue( { ...value, [field]:val } ) 
        setIsDifferent( true )
        props.onChange( val, field ) 
    }
    
    const onUpdate = () => {
        setIsDifferent( false )
        props.onUpdate()
    }
    
    const onUpdateClose = () => {
        setIsDifferent( false )
        props.onUpdate()
        // onClose()
    }

    return <Overlay2 isOpen={ true } hasBackdrop={ true } backdropClassName="overlay-light">
        <>
            <CanvasEditCanvas {...props} value={value} onChange={onChange} onUpdate={onUpdate} onClose={onClose} onUpdateClose={onUpdateClose} isDifferent={isDifferent} /> 
            <CanvasEditPanel  {...props} value={value} onChange={onChange} onUpdate={onUpdate} onClose={onClose} onUpdateClose={onUpdateClose} isDifferent={isDifferent} />
        </>
    </Overlay2>
}
export default CanvasEditForm


export interface ICanvasEditPanelProps extends ICanvasEditFormProps {
    isDifferent: boolean
    onUpdateClose: () => void
}
const CanvasEditPanel = (props: ICanvasEditPanelProps): JSX.Element => {
    const {value}               = props
    const [isOpen, setIsOpen]   = useState<boolean>( false )
    const [cur, setCur]         = useState<string>( "background" )
    const _schema               = useMemo<any>(() => schema(), []) 

    const onOpen = ( type: string ) => {
        setIsOpen( true )
        setCur( type )
    }
    const onUpdate = () => {
        props.onUpdate()
    } 
    const onAdd = () => {
        useLandingStore.setState({ isAddMeatDrawerOpen: true })
    }
    
    const item          = getFullSingleContentSchema( LANDING_TYPE_CONTENT.CANVAS, _schema ) 
    const schemaType    = item?.apollo_fields || {}
    const notClear      = true 

    const onChange = ( val: any, field: string, dop: any) => {
        props.onChange( val, field, ) 
    } 

    return <div className="max-height-auto h-auto p-2 m-0 w-100 landing-edit-switcher">
        <ButtonGroup className="w-100 z-index-120">
            <Hint label={__( "Add" ) } position={Position.BOTTOM_LEFT} >
                <Button variant={ButtonVariant.MINIMAL} icon="plus" onClick={ onAdd } className="" />  
            </Hint>
            <Hint label={__( "Background" ) } position={Position.BOTTOM_LEFT} >
                <Button variant={ButtonVariant.MINIMAL} onClick={ () => onOpen( "background" ) } className="">
                    <div className="d-flex flex-centered ">
                        <img src={ "/assets/img/landing/background.svg" } className="svg-force-plain" alt="" height={ 16 } /> 
                    </div>
                </Button>
            </Hint>
            <Hint label={__( "Style" ) } position={Position.BOTTOM_LEFT} >
                <Button variant={ButtonVariant.MINIMAL} onClick={ () => onOpen( "style" ) } className="">
                    <div className="d-flex flex-centered ">
                        <img src={ "/assets/img/landing/css.svg" } className="svg-force-plain" alt="" height={ 16 } /> 
                    </div>
                </Button>
            </Hint> 
            <Hint label={__( "Behovior" ) } position={Position.BOTTOM_LEFT} >
                <Button variant={ButtonVariant.MINIMAL} onClick={ () => onOpen( "behovior" ) } className="">
                    <div className="d-flex flex-centered ">
                        <img src={ "/assets/img/landing/actions.svg" } className="svg-force-plain" alt="" height={ 16 } /> 
                    </div>
                </Button>
            </Hint>
            <Hint label={__( "Position" ) } position={Position.BOTTOM_LEFT} >
                <Button variant={ButtonVariant.MINIMAL} onClick={ () => onOpen( "position" ) } className="">
                    <div className="d-flex flex-centered ">
                        <img src={ "/assets/img/landing/position.svg" } className="svg-force-plain" alt="" height={ 16 } /> 
                    </div>
                </Button>
            </Hint>
            <div className="ml-auto" />
            <Hint label={__( "Update" ) }  position={Position.BOTTOM_LEFT}>
                <Button 
                    intent={ props.isDifferent ? Intent.SUCCESS  : Intent.NONE } 
                    disabled={ !props.isDifferent } 
                    className={`${ props.isDifferent ? "" : "opacity_5" }`} 
                    onClick={ onUpdate }
                >
                    <div className="d-flex align-items-center ">
                        <Icon icon="floppy-disk"/> 
                    </div>
                </Button>
            </Hint> 
            <Button 
                onClick={props.onUpdateClose} 
                className={`ml-1 ${ props.isDifferent ? "" : "opacity_5" }`} 
                disabled={ !props.isDifferent } 
            >
                <div className="d-flex align-items-center ">
                    <Icon icon="saved"/> 
                    <div className="ml-1 small letter-spacing-2">{ __( "Update and close" ) }</div>
                </div>
            </Button>
            <Hint label={__( "Close" ) }  position={Position.BOTTOM_LEFT}>
                <Button onClick={props.onClose} className="ml-1">
                    <div className="d-flex align-items-center ">
                        <Icon icon="cross"/>
                    </div>
                </Button>
            </Hint>  
        </ButtonGroup>
        <Drawer
            isOpen={ isOpen }
            onClose={ () => setIsOpen( false ) }
            position="left"
            size={400}
            hasBackdrop={false}
            portalClassName="canvas-edit-drawer"
        >
            <div className="overflow-y-auto mx-3">
                <div className="title letter-spacing-2 mb-3">
                    { __( item.tabs.find((tab: any) => tab._id === cur)?.title ) }
                </div> 
                {
                    Object.keys(schemaType)
                        .filter( (key: string) => schemaType[key]?.tab === cur)
                        .filter( key => { 
                            /* Скрыть, если хотя бы один из стека require=false */
                            return isShowByGrands(schemaType, key, value)
                        })
                        .filter((af: string) => !schemaType[af].parent)
                        .map(key => { 
                            return <div className={ `row data-list ${  "w-auto" }` } key={ key }> 
                                <div className="container pr-5">
                                    <FieldChanger 
                                        value={ value ? value[ key ] : undefined }
                                        { ...schemaType[ key ] } 
                                        field={ key }
                                        dataName={ key }
                                        origin={ value }
                                        onChange={ onChange }
                                        sectionId={props.sectionId}
                                        notClear={notClear}
                                    />
                                </div>
                            </div>
                        })
                } 
            </div>            
            <Button className="close-btn m-2 px-3 py-2" intent={ Intent.DANGER } icon="cross" onClick={ () => setIsOpen( false ) } />
        </Drawer>
    </div>
}